import { useEffect, useId, type ReactNode } from 'react';
import { Ayuda } from './Ayuda';

/** Panel deslizante por la derecha (escritorio, 560 px) y a pantalla completa en móvil.
 *  Cierra con Escape, con la ✕ y con click en el fondo. */
export function PanelLateral({ titulo, ayuda, onCerrar, children }: { titulo: string; ayuda?: string; onCerrar: () => void; children: ReactNode }) {
  const tituloId = useId();
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onCerrar(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onCerrar]);
  return (
    <div className="fixed inset-0 z-40" role="presentation">
      <div className="absolute inset-0 bg-azul-noche/30" onClick={onCerrar} aria-hidden="true" />
      <aside role="dialog" aria-modal="true" aria-labelledby={tituloId} className="absolute inset-y-0 right-0 flex w-full flex-col bg-white shadow-2xl sm:w-[560px]">
        <div className="flex h-14 shrink-0 items-center justify-between border-b border-slate-200 px-4">
          <h2 id={tituloId} className="flex items-center gap-1.5 text-[15px] font-medium text-azul-noche">{titulo}{ayuda && <Ayuda texto={ayuda} />}</h2>
          <button type="button" onClick={onCerrar} aria-label="Cerrar" className="flex h-9 w-9 items-center justify-center rounded-lg text-gris hover:bg-slate-100 hover:text-azul-noche">✕</button>
        </div>
        <div className="min-h-0 flex-1 overflow-y-auto p-4">{children}</div>
      </aside>
    </div>
  );
}
